import getPrizeAdditionalOffset from './getPrizeAdditionalOffset';

export default getPrizeAdditionalOffset;
